import { useRollbar } from '@rollbar/react';
import type { AuthenticatedUser } from '@src/authentication/AuthenticatedUser';

type LogArg = string | string[] | object | Error;

export interface AlertingService {
  error: (...args: LogArg[]) => void;
}

export const useAlerting = (): AlertingService => {
  const rollbar = useRollbar();

  return {
    error: (...args: LogArg[]) => {
      rollbar.error(args);
    },
  };
};

interface ConfigureAlerting {
  configureActiveUser: (user: AuthenticatedUser) => void;
}

export const useConfigureAlerting = (): ConfigureAlerting => {
  const rollbar = useRollbar();

  return {
    configureActiveUser: (user: AuthenticatedUser) => {
      rollbar.configure({
        payload: {
          person: {
            id: user.id,
            name: user.name,
            username: user.email,
            email: user.email,
          },
        },
      });
    },
  };
};
